/* runwell-bundle-system: assets/runwell-bundle-system.js.

   Two responsibilities in v1:
   1. FOMO countdown ticker for the discount-deadline strip on bundle PDPs.
      Cycles every fomo_cycle_days days. No external libs; tabular-nums
      keeps the digits from jumping.
   2. Mode A radio change handler: keeps the ATC button label in sync
      with the selected quantity (purely UX; the form submission carries
      the qty as a hidden input).

   Surface 4 (cart drawer cross-sell) JS lives here too once BS-6 ships.
*/

(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function startCountdown(el) {
    const cycleDays = parseInt(el.dataset.fomoCycleDays || '30', 10);
    if (!cycleDays || cycleDays <= 0) return;

    const cycleMs = cycleDays * 24 * 60 * 60 * 1000;
    const epoch = new Date('2026-01-01T00:00:00Z').getTime();
    const timeEl = el.querySelector('[data-runwell-fomo-time]');
    if (!timeEl) return;

    function tick() {
      const now = Date.now();
      const elapsedInCycle = (now - epoch) % cycleMs;
      const remainingMs = cycleMs - elapsedInCycle;
      const days = Math.floor(remainingMs / (24 * 60 * 60 * 1000));
      const hours = Math.floor((remainingMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));

      if (days > 0) {
        timeEl.textContent = days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm';
      } else {
        const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);
        timeEl.textContent = pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function initFomo() {
    document
      .querySelectorAll('[data-runwell-fomo]')
      .forEach(function (el) {
        const mode = el.dataset.fomoMode;
        if (mode === 'discount' || mode === 'both') startCountdown(el);
      });
  }

  function initTierSync() {
    document
      .querySelectorAll('.runwell-bundle-system__tiers')
      .forEach(function (fieldset) {
        fieldset.addEventListener('change', function (e) {
          if (!e.target.matches('.runwell-bundle-system__tier-input')) return;
          fieldset
            .querySelectorAll('.runwell-bundle-system__tier')
            .forEach(function (label) {
              const input = label.querySelector('.runwell-bundle-system__tier-input');
              label.classList.toggle('is-selected', input.checked);
            });
        });
      });
  }

  /* -------------------------------------------------------------------
   * Mode A quantity builder
   *
   * Per-tier radio selection state + image thumbnail swap + ATC.
   * ATC handles two cases:
   *   1. Plain tier: standard product form POST.
   *   2. free_gift tier: intercept the submit, build a multi-line
   *      /cart/add.js POST with the bundle qty + 1 of the free gift
   *      product (read from data-free-gift-variant-id on the section).
   * After success: open Dawn cart drawer + dispatch cart:updated so any
   * downstream xsell listeners refresh.
   * ----------------------------------------------------------------- */
  function initQuantityBuilder() {
    document
      .querySelectorAll('[data-runwell-bundle-quantity-builder]')
      .forEach(function (section) {
        // Tier selection visual state
        section
          .querySelectorAll('[data-runwell-tier-radio]')
          .forEach(function (radio) {
            radio.addEventListener('change', function () {
              section
                .querySelectorAll('.runwell-bundle-quantity-builder__option')
                .forEach(function (label) {
                  const input = label.querySelector('[data-runwell-tier-radio]');
                  label.classList.toggle(
                    'runwell-bundle-quantity-builder__option--selected',
                    input ? input.checked : false
                  );
                });
            });
          });

        // Thumbnail swap (image gallery)
        section.querySelectorAll('[data-thumb]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            const idx = btn.dataset.thumb;
            section
              .querySelectorAll('.runwell-bundle-quantity-builder__slide')
              .forEach(function (s) {
                s.classList.toggle(
                  'runwell-bundle-quantity-builder__slide--active',
                  s.dataset.slide === idx
                );
              });
            section
              .querySelectorAll('.runwell-bundle-quantity-builder__thumb')
              .forEach(function (t) {
                t.classList.toggle(
                  'runwell-bundle-quantity-builder__thumb--active',
                  t === btn
                );
              });
          });
        });

        // ATC handler
        const form = section.querySelector('[data-runwell-bundle-form]');
        if (!form) return;
        const atc = form.querySelector('[data-runwell-bundle-atc]');
        const giftVariantId = section.dataset.freeGiftVariantId || '';

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const selected = form.querySelector(
            '.runwell-bundle-quantity-builder__option--selected'
          );
          if (!selected) return;
          const qty = parseInt(selected.dataset.tierQty || '1', 10);
          const wantsGift = selected.dataset.tierFreeGift === 'true' && giftVariantId !== '';
          const baseVariantId = form.querySelector('input[name="id"]').value;

          // Subscription tier: pick the N-pack variant + selling plan from
          // the tier's data attributes. Cart adds qty=1 of the N-pack
          // (the variant.price IS the tier total; the pack contains qty
          // units). One-time tier: add qty of the base variant.
          const isSub = selected.dataset.tierPurchaseMode === 'subscription';
          const tierVariantId = selected.dataset.tierVariantId || '';
          const tierSellingPlanId = selected.dataset.tierSellingPlanId || '';

          setAtcState(atc, 'loading');

          let firstItem;
          if (isSub && tierVariantId) {
            firstItem = {
              id: parseInt(tierVariantId, 10),
              quantity: 1,
            };
            if (tierSellingPlanId) {
              firstItem.selling_plan = parseInt(tierSellingPlanId, 10);
            }
          } else {
            firstItem = {
              id: parseInt(baseVariantId, 10),
              quantity: qty,
            };
          }
          const items = [firstItem];
          if (wantsGift) {
            items.push({ id: parseInt(giftVariantId, 10), quantity: 1 });
          }

          // Dawn's cart-drawer needs the cart-drawer + cart-icon-bubble
          // sections re-rendered before .open() will show the new items
          // (it starts in is-empty state and renderContents() updates +
          // opens in one call). We pass `sections` to /cart/add.js so the
          // response includes the freshly rendered HTML for each.
          const drawer = document.querySelector('cart-drawer');
          const cartSections = drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean)
            : ['cart-drawer', 'cart-icon-bubble'];

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: cartSections, sections_url: window.location.pathname }),
          })
            .then(function (r) {
              if (!r.ok) {
                return r.text().then(function (text) {
                  throw new Error('cart/add ' + r.status + ': ' + text.slice(0, 200));
                });
              }
              return r.json();
            })
            .then(function (json) {
              setAtcState(atc, 'added');
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

              // Dawn pattern: renderContents(parsedState) updates each
              // section's DOM from json.sections and opens the drawer.
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.renderContents(json);
                // Dawn's renderContents updates #CartDrawer-CartItems but
                // does NOT toggle the `is-empty` class on the outer
                // <cart-drawer> element. CSS keeps the line items area
                // hidden while that class is present, so after the first
                // ATC of a session items render in DOM but stay visually
                // hidden. Remove the class now that the cart has items.
                drawer.classList.remove('is-empty');
                setTimeout(function () { setAtcState(atc, 'idle'); }, 2000);
                return;
              }
              // Fallback A: drawer exists but no renderContents (older
              // theme). Open and hope the drawer fetches fresh state.
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
                setTimeout(function () { setAtcState(atc, 'idle'); }, 2000);
                return;
              }
              // Fallback B: send customer to /cart so they always land
              // somewhere they can verify the items.
              setTimeout(function () { window.location.href = '/cart'; }, 600);
            })
            .catch(function (err) {
              console.error('[runwell-bundle] ATC failed:', err);
              setAtcState(atc, 'idle');
              if (atc) {
                const textEl = atc.querySelector('.runwell-bundle-quantity-builder__atc-text');
                if (textEl) {
                  const original = textEl.textContent;
                  textEl.textContent = 'Could not add. Try again.';
                  setTimeout(function () { textEl.textContent = original; }, 3000);
                }
              }
            });
        });
      });
  }

  function setAtcState(atc, state) {
    if (!atc) return;
    const textEl = atc.querySelector('.runwell-bundle-quantity-builder__atc-text');
    const loadEl = atc.querySelector('.runwell-bundle-quantity-builder__atc-loading');
    if (!textEl || !loadEl) return;
    if (state === 'loading') {
      textEl.style.display = 'none';
      loadEl.style.display = 'inline';
      atc.disabled = true;
    } else if (state === 'added') {
      loadEl.style.display = 'none';
      textEl.textContent = 'ADDED';
      textEl.style.display = 'inline';
    } else {
      loadEl.style.display = 'none';
      textEl.textContent = 'ADD TO CART';
      textEl.style.display = 'inline';
      atc.disabled = false;
    }
  }

  /* -------------------------------------------------------------------
   * Cart-drawer xsell refresh
   *
   * The cart drawer is server-rendered once. When customers add or
   * change items via async fetch (PDP ATC, qty controls, remove), the
   * bundle xsell area would otherwise stay stale. We hook fetch() to
   * detect cart mutations, then re-render #CartDrawer-XsellSlot from
   * the current page's cart-drawer section via Section Rendering API.
   *
   * Tenants opt in by adding <div id="CartDrawer-XsellSlot"> around the
   * bundle xsell in their cart-drawer snippet (or by using the
   * snippets/runwell-bundle-cart-xsell.liquid wrapper which does this).
   * If the slot isn't present, this is a no-op.
   * ----------------------------------------------------------------- */
  function initCartMutationRefresh() {
    if (window.__runwellBundleCartRefreshInstalled) return;
    window.__runwellBundleCartRefreshInstalled = true;

    const MUTATION_RE = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/;
    let pending = null;

    function scheduleRefresh() {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        refresh();
      }, 120);
    }

    function refresh() {
      const slot = document.getElementById('CartDrawer-XsellSlot');
      if (!slot) return;
      const url =
        window.location.pathname +
        (window.location.search ? window.location.search + '&' : '?') +
        'sections=cart-drawer';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          const html = data && data['cart-drawer'];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById('CartDrawer-XsellSlot');
          if (!fresh) return;
          slot.innerHTML = fresh.innerHTML;
        })
        .catch(function () {
          /* silent; keep current xsell */
        });
    }

    const origFetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      const p = origFetch.apply(this, args);
      try {
        const first = args[0];
        const url = typeof first === 'string' ? first : (first && first.url) || '';
        if (MUTATION_RE.test(url)) {
          p.then(scheduleRefresh, function () {});
        }
      } catch (e) {}
      return p;
    };

    ['cart:updated', 'cart:refresh', 'cart-drawer:updated'].forEach(function (name) {
      document.addEventListener(name, scheduleRefresh);
    });
  }

  function initFilterChip() {
    document
      .querySelectorAll('[data-runwell-bundle-filter-chip]')
      .forEach(function (chip) {
        const section = chip.closest('.runwell-bundle-collection--filter-chip');
        if (!section) return;
        const handlesAttr = section.dataset.bundleHandles || '';
        const bundleHandles = handlesAttr
          .split(',')
          .map(function (h) { return h.trim(); })
          .filter(Boolean);

        function applyFilter(active) {
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
          const cards = document.querySelectorAll(
            '.product-grid .product-card, .grid__item .card-wrapper, [data-product-handle]'
          );
          cards.forEach(function (card) {
            const handle =
              card.dataset.productHandle ||
              (card.querySelector('[data-product-handle]') || {}).dataset?.productHandle ||
              '';
            const tags = (card.dataset.tags || '').toLowerCase();
            const isBundle = bundleHandles.indexOf(handle) !== -1 || tags.indexOf('bundle') !== -1;
            card.style.display = active && !isBundle ? 'none' : '';
          });
          const url = new URL(window.location.href);
          if (active) {
            url.searchParams.set('filter', 'bundle');
          } else {
            url.searchParams.delete('filter');
          }
          window.history.replaceState({}, '', url);
        }

        chip.addEventListener('click', function () {
          const active = chip.getAttribute('aria-pressed') === 'true';
          applyFilter(!active);
        });

        const initial = new URL(window.location.href).searchParams.get('filter') === 'bundle';
        if (initial) applyFilter(true);
      });
  }

  /* ---------- Surface 4: cart drawer bundle cross-sell ---------- */

  function readBundleIndex() {
    const el = document.querySelector('[data-runwell-bundle-index]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function findBundleMatch(cartHandles, bundleIndex) {
    if (!bundleIndex || !bundleIndex.products || !bundleIndex.bundles) return null;
    const candidates = new Set();
    cartHandles.forEach(function (h) {
      (bundleIndex.products[h] || []).forEach(function (b) {
        candidates.add(b);
      });
    });
    let best = null;
    candidates.forEach(function (bundleHandle) {
      const bundle = bundleIndex.bundles[bundleHandle];
      if (!bundle || !bundle.components) return;
      const compHandles = Object.keys(bundle.components);
      const inCart = compHandles.filter(function (h) {
        return cartHandles.indexOf(h) !== -1;
      });
      if (inCart.length >= 1 && inCart.length < compHandles.length) {
        if (!best || inCart.length > best.matchCount) {
          best = { bundleHandle: bundleHandle, matchCount: inCart.length, total: compHandles.length };
        }
      }
    });
    return best;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  function fetchBundleProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function renderCard(slot, bundleProduct, eyebrow, cta) {
    if (!bundleProduct) return;
    slot.innerHTML =
      '<p class="runwell-bundle-cart-xsell__eyebrow">' + escapeHtml(eyebrow) + '</p>' +
      '<div class="runwell-bundle-cart-xsell__card">' +
        (bundleProduct.featured_image
          ? '<img class="runwell-bundle-cart-xsell__thumb" loading="lazy" width="60" height="60" alt="" src="' + bundleProduct.featured_image + '">'
          : '') +
        '<div class="runwell-bundle-cart-xsell__details">' +
          '<p class="runwell-bundle-cart-xsell__name">' + escapeHtml(bundleProduct.title) + '</p>' +
          '<p class="runwell-bundle-cart-xsell__price">' + formatMoney(bundleProduct.price) + '</p>' +
        '</div>' +
        '<button type="button" class="runwell-bundle-cart-xsell__cta" data-runwell-bundle-cta data-bundle-handle="' + bundleProduct.handle + '" data-bundle-variant-id="' + bundleProduct.variants[0].id + '">' + escapeHtml(cta) + '</button>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function addBundleAndRemoveComponents(variantId, componentHandles, cart) {
    const updates = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (componentHandles.indexOf(item.handle) !== -1) {
          updates[item.key] = 0;
        }
      });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (Object.keys(updates).length === 0) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  function initCartXsell() {
    const slot = document.querySelector('[data-runwell-bundle-xsell-slot]');
    if (!slot) return;
    const bundleIndex = readBundleIndex();
    if (!bundleIndex) return;

    function evaluate() {
      fetchCart().then(function (cart) {
        const cartHandles = (cart.items || []).map(function (i) { return i.handle; });
        if (cartHandles.length === 0) {
          slot.innerHTML = '';
          return;
        }
        const match = findBundleMatch(cartHandles, bundleIndex);
        if (!match) {
          slot.innerHTML = '';
          return;
        }
        fetchBundleProduct(match.bundleHandle).then(function (bp) {
          if (!bp || !bp.variants || bp.variants.length === 0) {
            slot.innerHTML = '';
            return;
          }
          renderCard(slot, bp, slot.dataset.eyebrow || 'Complete the stack', slot.dataset.cta || 'Add bundle and save');
          document.dispatchEvent(new CustomEvent('runwell:bundle-xsell-active', { detail: { bundleHandle: match.bundleHandle } }));

          const cta = slot.querySelector('[data-runwell-bundle-cta]');
          if (cta) {
            cta.addEventListener('click', function () {
              const vid = parseInt(cta.dataset.bundleVariantId, 10);
              const handle = cta.dataset.bundleHandle;
              const bundle = bundleIndex.bundles[handle];
              const componentHandles = bundle ? Object.keys(bundle.components) : [];
              cta.disabled = true;
              addBundleAndRemoveComponents(vid, componentHandles, cart).catch(function () {
                cta.disabled = false;
              });
            });
          }
        });
      });
    }

    evaluate();
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, evaluate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFomo();
      initTierSync();
      initFilterChip();
      initCartXsell();
      initQuantityBuilder();
      initCartMutationRefresh();
    });
  } else {
    initFomo();
    initTierSync();
    initFilterChip();
    initCartXsell();
    initQuantityBuilder();
    initCartMutationRefresh();
  }
})();
